export type HttpHeaders = { [name: string]: string };

export interface HttpRequestOptions {
  method: HttpRequestMethod;
  url: string;
  body?: HttpRequestBody;
  headers?: HttpHeaders;
}

export type HttpRequestBody = object;

export enum HttpRequestMethod {
  Post = "POST",
}
